import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {AnyImageOpContext, ImageOpOutputs} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/operators/shared/nodes/prepare-mask/definition"
import {ImageOpNodeDataObject} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/data-object/node"
import {ImageOpNodeCreateImage} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/create-image/node"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {CompositeImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/composite-image-op-node"

@registerNode
export class ImageOpNodePrepareMask extends CompositeImageOpNode<typeof definition> {
    static nodeClass = "ImageOpNodePrepareMask"
    static definition = definition

    override async execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<typeof definition>> {
        const {dataObjectId, descriptor} = await evaluator.getAll(this.parameters)
        const result = dataObjectId
            ? imageOpNodeBag.getNode("sourceDataObject", ImageOpNodeDataObject, {
                  dataObjectId: dataObjectId,
                  downloadFormat: "exr",
                  descriptor: descriptor,
              })
            : imageOpNodeBag.getNode("sourceEmptyImage", ImageOpNodeCreateImage, {
                  descriptor: descriptor,
                  data: 0,
              })
        return await evaluator.get(result)
    }
}
